var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce"},[_c('textarea',{attrs:{"id":_vm.tinymceId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }